import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/settings_/locations/$locationId/divisions')({
  component: lazyRouteComponent(() => import('&/features/settings/divisions/pages/divisions-page')),
  staticData: { titleKey: 'divisions' },
});
